import DaaSTable, { DaasTableColumn } from '@/components/table/DaasTable';
import { FunctionComponent } from 'react';
import { StandardisedProduct } from './StockProvisionPage';
import { StockProvisionStandardProductTableRow } from './StockProvisionStandardProductTableRow';

export interface StockProvisionStandardProductTableData {
  product: StandardisedProduct;
}

const tableHeaders: DaasTableColumn[] = [
  {
    accessor: 'deviceName',
    text: 'Device Name',
    size: '1fr'
  },
  {
    accessor: 'sku',
    text: 'SKU',
    size: '0.4fr'
  },
  {
    accessor: 'quantity',
    text: 'Qty',
    size: '0.2fr'
  }
];

interface StockProvisionStandardProductTableProps {
  products: StandardisedProduct[];
  onChangeCallback: (productId: string, count: number) => void;
}

export const StockProvisionStandardProductTable: FunctionComponent<StockProvisionStandardProductTableProps> = ({
  products,
  onChangeCallback
}) => {
  return (
    <DaaSTable className="max-h-[30rem] overflow-y-auto" headers={tableHeaders}>
      {products.map(product => (
        <StockProvisionStandardProductTableRow
          key={product.product.id}
          data={product}
          onChangeCallback={onChangeCallback}
        />
      ))}
    </DaaSTable>
  );
};
